// Global constants and lighting presets.

export const U = 0.18; // inches -> scene units
export const FLIP_U = false; // set true if cover text appears mirrored

export interface LightingPreset {
  name: string;
  tempK: number;
  tint: number;
  exposure: number;
}

export type BackdropMode = 'transparent' | 'flat' | 'gradient' | 'studio';
export type ViewMode = 'turntable' | 'orbit';

// Edit these after calibrating against a real printed book (use "Copy settings").
export const PRESETS: LightingPreset[] = [
  { name: 'Screen (calibrated)', tempK: 5700, tint: -5, exposure: 1.0 },
  { name: 'Tungsten 3000K', tempK: 3000, tint: 4, exposure: 0.95 },
  { name: 'Neutral 5500K', tempK: 5500, tint: 0, exposure: 1.0 },
  { name: 'Daylight 6500K', tempK: 6500, tint: 0, exposure: 1.0 },
  { name: 'Cool 7500K', tempK: 7500, tint: -3, exposure: 1.05 },
];
